import { State } from '@meraki-internal/state';

export class CareMapDrawerTrackingHelper extends State {

    constructor() {
        super({});
    };

    setTrackingFrom = (from: string) => {
        this.setState({ trackingFrom: from });
    };

    clearTrackingFrom = () => {
        this.setState({ trackingFrom: undefined });
    };
};
